/* eslint-disable import/prefer-default-export */
import { RootState } from '../index';

export const selectAuth = (state: RootState) => state.auth;
export const selectAlert = (state: RootState) => state.alert;
export const selectModal = (state: RootState) => state.modal;
export const selectCart = (state: RootState) => state.cart;
export const selectOrder = (state: RootState) => state.order;
export const selectPrinter = (state: RootState) => state.printer;
